import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPProductDescriptionUI from './PDPProductDescriptionUI';

const PDPProductDescriptionInner = () => {
  const {
    loading,
    error,
    data: { description, dimensions, additional_attributes },
  } = useProductAttributes();

  if (error) {
    return null;
  }

  return (
    <PDPProductDescriptionUI
      loading={loading}
      headline={description}
      dimensions={dimensions}
      description={additional_attributes?.showpiece_desc}
    />
  );
};

const PDPProductDescription = props => (
  <SuspenseWithLoader fallback={<PDPProductDescriptionUI loading />}>
    <PDPProductDescriptionInner {...props} />
  </SuspenseWithLoader>
);

export default PDPProductDescription;
